import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclWrappingService {

  constructor() { }

  processWrappingOpen(
    intervalObj,
    wrapActionDefinition,
    parent,
    elemOpenId,
    key,
    title,
    bgColor,
    fgColor,
    borderColor,
    enableMatFormFix,
    wrapHeading,
    wrapClass,
    iconClass,
    iconStyle,
    fullwidth,
    parentNode,
    wrappingCloseFn,
    updateUIFn?
  ) {

    let wrapAction = '';
    if (!(typeof wrapActionDefinition === 'undefined' || wrapActionDefinition == null)) {
      wrapAction = wrapActionDefinition;
    }

    if (wrapAction === 'open') {

      if (intervalObj == null) {

        if (parent != null) {

          clearInterval(intervalObj);
          intervalObj = null;

          const parentId = parent.getAttribute('id');
          if (parentId) {
            parent.setAttribute('id', elemOpenId);
            parent.classList.add(parentId);
          }
          
          parent.setAttribute('key', key);
          parent.setAttribute('static-html-wrap', elemOpenId);
          parent.setAttribute('static-html-wrap-heading-title', title ? title : '');
          parent.setAttribute('static-html-wrap-heading-bg', bgColor);
          parent.setAttribute('static-html-wrap-heading-fg', fgColor);
          parent.setAttribute('static-html-wrap-border', borderColor);

          if (enableMatFormFix) {
            parent.classList.add('enable-mat-form-fix');
          }

          let isWrapHeading = true;
          if (!(wrapHeading == null)) { isWrapHeading = wrapHeading; }

          parent.setAttribute('static-html-wrap-heading', isWrapHeading);
          parent.setAttribute('static-html-wrap-class', wrapClass);
          parent.setAttribute('static-html-icon-class', iconClass);
          parent.setAttribute('static-html-icon-style', iconStyle);
          parent.setAttribute('static-html-wrap-fullwidth', fullwidth);

          if (updateUIFn && typeof updateUIFn === 'function') {
            updateUIFn();
          }
          if (wrappingCloseFn && typeof wrappingCloseFn === 'function') {
            wrappingCloseFn();
          }
        } else {
          parent = parentNode;
        }

      }

    }

    return { wrapAction, intervalObj };
  }

  handlePanelIcon(open, panel) {

    const wrapId = open.getAttribute('id');
    const iconClass = open.getAttribute('static-html-icon-class');
    const hasIconClass = iconClass && iconClass !== 'undefined';
    const iconStyle = open.getAttribute('static-html-icon-style');
    const hasIconStyle = iconStyle && iconStyle !== 'undefined';

    if (hasIconClass || hasIconStyle) {
      const icon = document.createElement('div');

      const iconDiv = document.createElement('div');
      iconDiv.setAttribute('id', `circled${wrapId}`);
      iconDiv.className = 'fbPanelBackgroundCircle';

      const iWrap = document.createElement('i');
      if (hasIconClass) {
        iWrap.classList.add('ico');
        iWrap.classList.add(...iconClass.split(' '));
        iWrap.classList.add('fa-fw', 'defaultIconClass');

        panel.classList.add('hasIcon');
      }

      if (hasIconStyle) {
        iWrap.style.cssText = iconStyle;
      }

      iconDiv.appendChild(iWrap);
      icon.appendChild(iconDiv);
      panel.appendChild(icon);

    }
  }

  handlePanelHead(open, panel, className) {
    
    const wrapId = open.getAttribute('id');

    const wrapHeading = open.getAttribute('static-html-wrap-heading');
    const headingHtml = open.getAttribute('static-html-wrap-heading-title');
    const bg = open.getAttribute('static-html-wrap-heading-bg');
    const fg = open.getAttribute('static-html-wrap-heading-fg');
    const border = open.getAttribute('static-html-wrap-border');

    const head = document.createElement('div');
    head.className = className; // 'sc-panel-head'
    head.setAttribute('id', wrapId + 'head');
    head.innerHTML = headingHtml;

    if (bg !== '') {
      head.style.background = bg;
    }

    if (fg !== '') {
      head.style.color = fg;
    }

    if (border !== '') {
      panel.style.borderColor = border;
      head.style.borderColor = border;
    }

    if (wrapHeading === 'true') {
      panel.appendChild(head);
    }
  }

  handlePanelBody(open, panel, className, isStaticHtmlComp) {

    const wrapId = open.getAttribute('id');

    const body = document.createElement('div');
    body.className = className; // 'sc-panel-body';

    if (isStaticHtmlComp) {
      body.style.display = 'flex';
      body.style['flex-wrap'] = 'wrap';
    }

    body.setAttribute('id', wrapId + 'collapsable');

    panel.appendChild(body);
  }

  handlePanel(parent, open, close, classNames, isStaticHtmlComp) {

    const wrapId = open.getAttribute('id');

    const panel = document.createElement('div');
    panel.setAttribute('id', `${wrapId}panel`);
    panel.setAttribute('close-class', close.className);
    panel.style.padding = "0px";

    const wrap_class = (open.getAttribute('static-html-wrap-class') !== 'undefined') ? open.getAttribute('static-html-wrap-class') : classNames.wrapClassDefault;
    let panelClass = 'panel ft-panel-wrap ' + wrap_class + ' ' + open.className.replace('ng-hide', '');
    if (isStaticHtmlComp) {
      panelClass = panelClass.replace(/ft-grid-col-[0-9]/g, 'ft-grid-col-12');
    }
    panel.className = panelClass;

    this.handlePanelIcon(open, panel);
    this.handlePanelHead(open, panel, classNames.head);
    this.handlePanelBody(open, panel, classNames.collapsable, isStaticHtmlComp);

    parent.firstChild.appendChild(panel);
  }

  processWrappingClose(isStaticHtmlComp, elemOpenId, parent, siblings, siblingsGrid, classNames) {
    let success = false;
    let headId = `#${elemOpenId}head`;

    try {

      const open = document.getElementById(elemOpenId);
      const close = parent;

      let wrapElement: HTMLElement = open;
      while (wrapElement) {

        if (wrapElement.nextSibling === close) { break; }

        wrapElement = wrapElement.nextSibling as HTMLElement;

        if (wrapElement == null) { continue; }

        siblings.push(wrapElement);

        if (wrapElement && wrapElement.className) {
          if (wrapElement.className.match(/ft-grid-col-[0-9]/g)) {
            siblingsGrid += parseInt(wrapElement.className.match(/ft-grid-col-[0-9]/g)[0].split('-')[3], 10);
          } else if (wrapElement.className === 'ft-component-wrap ng-untouched ng-pristine ng-valid ng-star-inserted') {
            siblingsGrid += 3;
          }
        } else {
          // siblingsGrid += parseInt(wrapElement.className.match(/col-lg-[0-9]/g)[0].split("-")[3]);
        }
      }

      const openFullwidth = open.getAttribute('static-html-wrap-fullwidth').toLowerCase();
      let newFtGrid = openFullwidth === 'false' ? (siblingsGrid >= 12 ? 12 : siblingsGrid) : 12;
      if (!isStaticHtmlComp) {
        open.className = open.className.replace(/ft-grid-col-[0-9]/g, 'ft-grid-col-' + newFtGrid); // panel-collapse
      }
      open.className = open.className.replace(/col-lg-[0-9]/g, 'col-lg-' + 12);

      this.handlePanel(parent, open, close, classNames, isStaticHtmlComp);

      success = true;

    } catch (err) {
      console.log('Encounter error. Going back to start wrapp ing');
      siblings = [];
    }

    return { siblings, siblingsGrid, success, headId };
  }


}

